import { isHorizontalCard } from './isHorizontalCard';

import { ITypedCard, ICombinedTypedCard } from '../types';

export function combineHorizontalCards(cards: ITypedCard[]): ICombinedTypedCard[] {
  return cards.reduce((combinedCards: ICombinedTypedCard[], card: ITypedCard, index, cards) => {
    const nextCard = (cards[index + 1] as ITypedCard | void) || null;
    const lastCombinedCard = (combinedCards[combinedCards.length - 1] as ICombinedTypedCard | void) || null;

    if (nextCard && isHorizontalCard(card) && isHorizontalCard(nextCard)) {
      combinedCards.push({ ...card, nextCard });

      return combinedCards;
    }

    if (lastCombinedCard && lastCombinedCard.nextCard === card) {
      return combinedCards;
    }

    combinedCards.push(card);

    return combinedCards;
  }, []);
}
